const initialState = {
    branchId: '0', 
    shopTitle: '',
    branchTitle: '',
    barcode: '',
    timerTime : 0,
};
const installmentsBarcode = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INSTALLMENTS_BARCODE_GENERATE_PAGE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default installmentsBarcode;
